import { correlationIdSchema as e, opaqueCursorSchema as t, pageLimitSchema as ee, uuidSchema as n } from "../common/index.js";
import * as r from "zod";
// src/schedules/index.ts
var i = 10, te = 14, ne = 20, a = 794, o = 1e4, s = r.number().int().positive(), c = r.iso.datetime({ offset: !0 }), l = r.iso.date().refine((e) => !e.startsWith("0000-"), "Use a supported calendar year from 0001 through 9999."), u = r.string().regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/), d = r.string().regex(/^[+-](?:[01]\d|2[0-3]):[0-5]\d$/);
function re(e) {
	if (/^[+-]/.test(e)) return !1;
	try {
		return new Intl.DateTimeFormat("en", { timeZone: e }), !0;
	} catch {
		return !1;
	}
}
var f = r.string().min(1).max(100).refine(re, "Use a valid IANA time zone."), p = r.string().transform((e) => e.normalize("NFC").trim()).pipe(r.string().refine((e) => [...e].length >= 1 && [...e].length <= 100, "Use 1–100 code points.").regex(/^[\p{L}\p{M}\p{N} _().-]+$/u).regex(/[\p{L}\p{N}]/u, "Include a letter or number."));
function ie(e) {
	return e.normalize("NFC").trim().toLocaleLowerCase("und");
}
var m = r.object({
	unit: r.enum(["day", "week"]),
	count: r.number().int().positive().max(2147483647)
}), h = r.object({
	startWeekday: r.number().int().min(1).max(7),
	startLocalMinute: r.number().int().min(0).max(1439),
	endWeekday: r.number().int().min(1).max(7),
	endLocalMinute: r.number().int().min(0).max(1439),
	fullWeek: r.boolean().default(!1)
}).refine((e) => e.fullWeek === (e.startWeekday === e.endWeekday && e.startLocalMinute === e.endLocalMinute), "Equal endpoints require explicit full-week coverage."), g = r.object({
	ordinal: r.number().int().min(0).max(19),
	userId: n
}), _ = r.array(g).min(1).max(20).refine((e) => e.every((e, t) => e.ordinal === t), "Positions must have contiguous ordered ordinals."), v = r.array(h).min(1).max(14), y = r.object({
	name: p,
	startLocalDate: l,
	anchorClockLocal: u,
	rotation: m,
	sections: v,
	participants: _,
	endedAt: c.nullable().optional()
}), ae = r.object({
	teamId: r.never().optional(),
	scheduleId: r.never().optional(),
	name: p,
	timeZone: f.default("Europe/Amsterdam"),
	routines: r.array(y).max(10).default([])
}), oe = y.extend({
	teamId: r.never().optional(),
	scheduleId: r.never().optional(),
	expectedVersion: s
}), se = r.object({
	teamId: r.never().optional(),
	scheduleId: r.never().optional(),
	timeZone: r.never().optional(),
	name: p,
	expectedVersion: s
}), ce = r.object({
	state: r.enum(["active", "archived"]).default("active"),
	cursor: t.optional(),
	limit: ee
}), b = r.object({
	id: n,
	teamId: n,
	name: p,
	timeZone: f,
	state: r.enum(["active", "archived"]),
	version: s,
	createdAt: c,
	archivedAt: c.nullable()
}), le = r.object({
	items: r.array(b).max(100),
	nextCursor: t.nullable()
}), x = r.object({
	kind: r.enum(["sections", "rotation"]),
	versionId: n,
	activatesAt: c,
	savedAt: c,
	effectiveLocalDate: l.optional()
}), S = y.extend({
	id: n,
	scheduleId: n,
	version: s,
	routineVersionId: n,
	createdAt: c,
	pendingChanges: r.array(x).max(2)
}), ue = b.extend({ routines: r.array(S).max(10) }), C = r.object({
	start: c,
	end: c
}).refine((e) => Date.parse(e.end) > Date.parse(e.start) && Date.parse(e.end) - Date.parse(e.start) <= 28584e5, "Use a positive range of at most one month plus two boundary days."), w = r.object({
	displayTimeZone: f,
	referenceDate: l,
	range: r.enum([
		"one-day",
		"one-week",
		"two-weeks",
		"one-month"
	]).default("two-weeks"),
	state: r.enum(["active", "archived"]).default("active")
}), de = r.object({
	expectedVersion: s,
	routine: y,
	window: w.omit({ state: !0 })
}), fe = w.omit({ state: !0 }).passthrough().refine((e) => e.state === void 0, "Personal calendars do not accept an archive state."), T = r.discriminatedUnion("mode", [
	r.object({ mode: r.literal("immediate") }),
	r.object({ mode: r.literal("cycle") }),
	r.object({
		mode: r.literal("date"),
		localDate: l
	})
]), E = r.object({
	teamId: r.never().optional(),
	scheduleId: r.never().optional(),
	timeZone: r.never().optional(),
	timing: T.optional(),
	name: p.optional(),
	startLocalDate: l.optional(),
	anchorClockLocal: u.optional(),
	rotation: m.optional(),
	participants: _.optional(),
	effectiveLocalDate: r.never().optional(),
	rotationChange: r.object({
		action: r.enum([
			"set",
			"revise",
			"cancel"
		]),
		timing: T.optional(),
		effectiveLocalDate: r.never().optional()
	}).optional(),
	endedAt: c.or(r.literal("now")).nullable().optional(),
	sectionChange: r.discriminatedUnion("action", [r.object({
		action: r.enum(["set", "revise"]),
		sections: v,
		timing: T.optional(),
		effectiveLocalDate: l.optional()
	}), r.object({ action: r.literal("cancel") })]).optional()
}).refine((e) => Object.entries(e).some(([e, t]) => e !== "timing" && t !== void 0), "Provide a routine change."), D = r.object({
	change: E,
	expectedVersion: s
}), O = r.string().min(1).max(256), pe = D.extend({
	previewFingerprint: O,
	confirmNewGaps: r.boolean().default(!1)
}), me = r.object({
	expectedVersion: s,
	previewFingerprint: O,
	confirmNewGaps: r.boolean().default(!1)
}), k = r.object({ expectedVersion: s }), A = k.extend({ previewFingerprint: O }), j = A.extend({ confirmed: r.literal(!0) }), M = r.object({
	scheduleId: n,
	expectedVersion: s,
	previewFingerprint: O,
	observedAt: c,
	searchedUntil: c,
	routines: r.array(r.object({
		routineId: n,
		name: p,
		currentCoverage: r.array(r.object({
			userId: n,
			displayName: r.string().min(1).max(500),
			originalUserId: n,
			overrideId: n.nullable(),
			end: c
		})).max(20),
		pendingVersions: r.array(r.object({
			id: n,
			effectiveAt: c,
			sectionChange: r.boolean(),
			rotationChange: r.boolean()
		})).max(2),
		overrides: r.array(r.object({
			overrideId: n,
			substituteUserId: n,
			displayName: r.string().min(1).max(500),
			start: c,
			end: c
		})).max(1e3),
		newGaps: r.array(r.object({
			start: c,
			end: c
		})).max(1e4)
	})).max(10)
}), N = r.object({
	scheduleId: n,
	version: s,
	routineIds: r.array(n).max(10),
	effectiveAt: c
}), P = r.object({
	routineId: n,
	version: s,
	effectiveAt: c,
	pendingChanges: r.array(x).max(2)
}), F = r.object({
	start: c.or(r.literal("now")),
	end: c,
	substituteUserId: n,
	reason: r.string().max(1e3).optional(),
	expectedVersion: s
}).refine((e) => e.start === "now" || Date.parse(e.end) > Date.parse(e.start), "Override end must follow start.").refine((e) => [e.start, e.end].every((e) => e === "now" || Date.parse(e) % 6e4 == 0), "Explicit endpoints use minute precision."), I = r.object({
	start: c.optional(),
	end: c.optional(),
	substituteUserId: n.optional(),
	reason: r.string().max(1e3).optional(),
	expectedVersion: s
}).refine((e) => e.start !== void 0 || e.end !== void 0 || e.substituteUserId !== void 0 || e.reason !== void 0, "Provide an override change.").refine((e) => e.start === void 0 || e.end === void 0 || e.start === "now" || Date.parse(e.end) > Date.parse(e.start), "Override end must follow start.").refine((e) => [e.start, e.end].every((e) => e === void 0 || Date.parse(e) % 6e4 == 0), "Explicit endpoints use minute precision."), L = r.object({
	overrideId: n,
	revision: s,
	version: s,
	effectiveAt: c
}), R = r.object({
	overrideId: n,
	routineId: n,
	scheduleId: n,
	version: s,
	start: c,
	end: c,
	substituteUserId: n,
	reason: r.string().max(1e3).nullable(),
	state: r.enum(["active", "canceled"]),
	editable: r.boolean()
}), z = r.object({
	scheduleId: n,
	routineId: n,
	routineVersionId: n,
	positionId: n,
	originalUserId: n,
	originalEligible: r.boolean(),
	overrideId: n.nullable()
}), B = r.object({
	start: c,
	end: c,
	source: z,
	userId: n.nullable(),
	eligible: r.boolean(),
	startOffset: d,
	endOffset: d,
	history: r.object({
		recordedThrough: c.nullable(),
		finalized: r.boolean()
	})
}).refine((e) => Date.parse(e.end) > Date.parse(e.start), "Intervals must be nonempty.").refine((e) => e.history.recordedThrough === null || Date.parse(e.history.recordedThrough) > Date.parse(e.start) && Date.parse(e.history.recordedThrough) <= Date.parse(e.end), "Recorded-through must be inside the assignment.").refine((e) => !e.history.finalized || e.history.recordedThrough !== null && Date.parse(e.history.recordedThrough) === Date.parse(e.end), "Only fully confirmed history can finalize an assignment."), V = r.object({
	overrideId: n,
	substituteUserId: n,
	start: c,
	end: c,
	effective: r.boolean(),
	eligible: r.boolean()
}).refine((e) => Date.parse(e.end) > Date.parse(e.start), "Intervals must be nonempty."), H = r.object({
	start: c,
	end: c,
	reason: r.enum([
		"outside-sections",
		"before-start",
		"ineligible",
		"ended",
		"archived",
		"empty-dst-section"
	])
}).refine((e) => Date.parse(e.end) >= Date.parse(e.start), "Gaps cannot have negative duration.").refine((e) => Date.parse(e.end) !== Date.parse(e.start) || e.reason === "empty-dst-section", "Only a DST empty section can have zero duration."), U = r.object({
	pendingHistory: C.nullable().optional(),
	routineId: n,
	name: p,
	rotation: m,
	original: r.array(B).max(o),
	overrides: r.array(V).max(o),
	final: r.array(B).max(o),
	gaps: r.array(H).max(o)
}), W = r.object({
	scheduleId: n,
	name: p,
	timeZone: f,
	version: s,
	routines: r.array(U).max(10)
}), G = r.object({
	id: n,
	displayName: r.string().min(1).max(500),
	initials: r.string().min(1).max(8)
}), K = r.array(G).max(1e3), he = r.object({ agents: K }), ge = r.object({ teams: r.array(r.object({
	id: n,
	name: r.string().min(1).max(500)
})).max(100) }), q = r.object({
	daySlices: r.array(C).max(35).optional(),
	agents: K.optional(),
	range: C,
	displayTimeZone: f,
	schedules: r.array(W).max(300),
	viewVersion: r.string().min(1).max(256)
}), J = r.object({
	activatesAt: c,
	preservesOutgoingTurn: r.boolean().optional(),
	outgoing: r.object({
		userId: n,
		ordinal: r.number().int().min(0).max(19),
		endsAt: c.nullable()
	}).nullable(),
	incoming: r.object({
		userId: n,
		ordinal: r.number().int().min(0).max(19),
		startsFreshTurn: r.boolean().optional()
	}).nullable()
}), Y = r.object({
	sections: c.optional(),
	rotation: c.optional()
}), _e = r.object({
	expectedVersion: s,
	previewFingerprint: O,
	effectiveAt: c,
	affectedRoutineIds: r.array(n).max(10),
	pendingChanges: r.array(x).max(2),
	before: q,
	after: q,
	changeActivations: Y.optional(),
	rotationTransition: J.optional(),
	routineEndAt: c.nullable().optional(),
	additionalWindows: r.array(r.object({
		before: q,
		after: q
	})).max(3).optional(),
	newGaps: r.array(H).max(o)
}), ve = r.object({ at: c.optional() }), X = r.object({
	userId: n,
	source: z,
	start: c,
	end: c
}).refine((e) => Date.parse(e.end) > Date.parse(e.start), "Duty intervals must be nonempty."), Z = r.object({
	scheduleId: n.nullable(),
	routineId: n.nullable(),
	originalUserId: n.nullable(),
	reason: r.enum([
		"no-schedules",
		"outside-sections",
		"before-start",
		"ineligible",
		"ended",
		"archived"
	])
}), ye = r.discriminatedUnion("outcome", [
	r.object({
		outcome: r.literal("covered"),
		agents: K.optional(),
		range: C.optional(),
		teamId: n,
		at: c,
		userIds: r.array(n).min(1).max(1e3),
		sources: r.array(X).min(1).max(3e3)
	}),
	r.object({
		outcome: r.literal("uncovered"),
		teamId: n,
		at: c,
		facts: r.array(Z).max(3e3)
	}),
	r.object({
		outcome: r.literal("unavailable"),
		teamId: n,
		at: c,
		reasonCode: r.enum([
			"STORAGE_UNAVAILABLE",
			"DEPENDENCY_UNAVAILABLE",
			"HISTORY_PENDING"
		]),
		correlationId: e
	})
]), be = r.object({
	sources: r.array(r.object({
		scheduleId: n,
		scheduleName: p,
		routineId: n,
		routineName: p
	})).max(3e3).optional(),
	timeline: q.optional(),
	agents: K.optional(),
	range: C,
	current: r.array(X).max(3e3),
	upcoming: r.array(X).max(o)
}), Q = r.object({
	timeZone: f,
	localDate: l,
	localTime: u
}), $ = r.object({
	instant: c,
	offset: d,
	occurrence: r.enum(["first", "second"])
}), xe = Q.extend({ candidates: r.array($).max(2) }).refine((e) => e.candidates.every((e, t) => e.occurrence === (t === 0 ? "first" : "second")), "Candidates are in occurrence order.").refine((e) => e.candidates.length < 2 || Date.parse(e.candidates[0].instant) < Date.parse(e.candidates[1].instant), "Candidates must be distinct and increasing."), Se = r.enum([
	"INVALID_REQUEST",
	"CAPABILITY_DENIED",
	"NOT_FOUND",
	"VERSION_CONFLICT",
	"IDEMPOTENCY_CONFLICT",
	"DEPENDENCY_BLOCKED",
	"DEPENDENCY_UNAVAILABLE",
	"INELIGIBLE_PARTICIPANT",
	"SCHEDULE_NAME_EXISTS",
	"ROUTINE_NAME_EXISTS",
	"SECTION_OVERLAP",
	"OVERRIDE_OVERLAP",
	"SCHEDULE_ARCHIVED",
	"STORAGE_UNAVAILABLE"
]), Ce = r.object({ expectedVersion: s }), we = C.and(r.object({ routineId: n.optional() })), Te = r.object({
	draftRoutineId: n,
	timeline: q
});
export { ne as MAX_ROUTINE_PARTICIPANTS, te as MAX_ROUTINE_SECTIONS, a as MAX_SCHEDULE_RANGE_HOURS, i as MAX_SCHEDULE_ROUTINES, o as MAX_TIMELINE_INTERVALS, X as dutyContributionSchema, he as eligibleScheduleAgentsSchema, $ as localTimeCandidateSchema, Q as localTimeOptionsQuerySchema, xe as localTimeOptionsSchema, ie as normalizeScheduleName, Ce as overrideCancelSchema, F as overrideCreateSchema, R as overrideDetailSchema, V as overrideIntervalSchema, L as overrideMutationResultSchema, I as overrideUpdateSchema, fe as ownDutyCalendarQuerySchema, be as ownDutySchema, ge as ownScheduleTeamsSchema, g as participantPositionSchema, x as pendingRoutineChangeSchema, J as rotationTransitionSchema, Y as routineChangeActivationsSchema, pe as routineChangeConfirmSchema, D as routineChangePreviewSchema, E as routineChangeSchema, de as routineCreatePreviewRequestSchema, Te as routineCreatePreviewResponseSchema, oe as routineCreateSchema, y as routineDefinitionSchema, P as routineMutationResultSchema, me as routinePendingCancelSchema, S as routineSummarySchema, U as routineTimelineSchema, T as routineTimingSchema, G as scheduleAgentSchema, K as scheduleAgentsSchema, M as scheduleArchivePreviewSchema, j as scheduleArchiveSchema, u as scheduleClockSchema, ae as scheduleCreateSchema, ue as scheduleDetailSchema, ve as scheduleDutyQuerySchema, ye as scheduleDutySchema, Se as scheduleErrorCodeSchema, H as scheduleGapSchema, c as scheduleInstantSchema, B as scheduleIntervalSchema, ce as scheduleListQuerySchema, l as scheduleLocalDateSchema, N as scheduleMutationResultSchema, p as scheduleNameSchema, d as scheduleOffsetSchema, le as schedulePageSchema, _ as scheduleParticipantsSchema, A as schedulePreviewConfirmSchema, O as schedulePreviewFingerprintSchema, _e as schedulePreviewSchema, C as scheduleRangeSchema, se as scheduleRenameSchema, m as scheduleRotationSchema, v as scheduleSectionsSchema, z as scheduleSourceSchema, b as scheduleSummarySchema, f as scheduleTimeZoneSchema, we as scheduleTimelineQuerySchema, q as scheduleTimelineSchema, W as scheduleTimelineSourceSchema, k as scheduleVersionRequestSchema, s as scheduleVersionSchema, w as teamTimelineQuerySchema, Z as uncoveredDutyFactSchema, h as weeklySectionSchema };

//# sourceMappingURL=index.js.map